import { APIEndpoint } from ".";

export interface CancellationRequestData {
  primaryReason: string;
  subReason?: string;
  usageFrequency?: string;
  satisfactionRatings?: {
    overall?: string;
    features?: string;
    pricing?: string;
    support?: string;
    ui?: string;
  };
  missingFeatures?: string[];
  alternativeService?: string;
  detailedFeedback: string;
  allowFollowUp?: boolean;
  metaEventId?: string;
}

export const cancelSubscription = async (data: CancellationRequestData) => {
  return fetch(APIEndpoint + "/subscriptions/cancel", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.success === true) {
        return res;
      } else {
        throw new Error(res.message || "Failed to cancel subscription");
      }
    })
    .catch((e) => {
      console.log("API Call, error canceling subscription", e);
      throw e;
    });
};

export const saveCancellationFeedback = async (data: CancellationRequestData) => {
  return fetch(APIEndpoint + "/subscriptions/feedback", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.success === true) {
        return res;
      } else {
        throw new Error(res.message || "Failed to save cancellation feedback");
      }
    })
    .catch((e) => {
      console.log("API Call, error saving cancellation feedback", e);
      throw e;
    });
};

